// client/src/components/transportadores/FiltroTransportadores.js
import React, { useState, useEffect } from 'react';
import { Search, X } from 'lucide-react';

const initialFilterState = {
    search: '',
    tipoPessoa: ''
};

const FiltroTransportadores = ({ onApplyFilters, activeFilters = {}, loading }) => {
    const [localFilters, setLocalFilters] = useState(initialFilterState);

    useEffect(() => {
        const cleanActive = Object.fromEntries(
            Object.entries(activeFilters).filter(([, v]) => v != null && v !== '')
        );
        setLocalFilters(prev => ({ ...initialFilterState, ...cleanActive }));
    }, [activeFilters]);

    const onChange = (e) => {
        setLocalFilters({ ...localFilters, [e.target.name]: e.target.value });
    };

    const onSubmit = (e) => {
        e.preventDefault();
        const filtersToApply = Object.fromEntries(
            Object.entries(localFilters).filter(([, v]) => v !== '' && v !== null && v !== undefined)
        );
        onApplyFilters && onApplyFilters(filtersToApply);
    };

    const handleClearFilters = () => {
        setLocalFilters(initialFilterState);
        onApplyFilters && onApplyFilters({});
    };

    const hasFilters = Object.values(localFilters).some(v => v !== '');

    return (
        <form onSubmit={onSubmit} className="bg-gray-50 p-4 rounded-lg border border-gray-200 mb-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 items-end">
                <div className="flex flex-col gap-1">
                    <label htmlFor="filter-transp-search" className="text-xs font-semibold text-gray-600 uppercase">Nome / Documento / Email</label>
                    <input
                        type="text" name="search" id="filter-transp-search"
                        placeholder="Buscar..."
                        value={localFilters.search} onChange={onChange}
                        className="form-input text-sm py-2 px-3 rounded border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                    />
                </div>

                <div className="flex flex-col gap-1">
                    <label htmlFor="filter-transp-tipoPessoa" className="text-xs font-semibold text-gray-600 uppercase">Tipo de Pessoa</label>
                    <select
                        name="tipoPessoa" id="filter-transp-tipoPessoa"
                        value={localFilters.tipoPessoa} onChange={onChange}
                        className="form-input text-sm py-2 px-3 rounded border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all bg-white"
                    >
                        <option value="">Todos</option>
                        <option value="Física">Pessoa Física</option>
                        <option value="Jurídica">Pessoa Jurídica</option>
                    </select>
                </div>

                {/* Antes reinventava cor do zero em Tailwind (bg-blue-600) */}
                <div className="flex gap-2 h-full">
                    <button
                        type="submit"
                        disabled={loading}
                        className="action-button action-button-primary flex-1 justify-center"
                        title="Aplicar Filtros"
                    >
                        <Search size={18} className="icon" />
                        Aplicar Filtros
                    </button>

                    {hasFilters && (
                        <button
                            type="button" onClick={handleClearFilters}
                            disabled={loading}
                            className="action-button action-button-secondary justify-center"
                            title="Limpar Filtros"
                        >
                            <X size={18} className="icon" />
                        </button>
                    )}
                </div>
            </div>
        </form>
    );
};

export default FiltroTransportadores;
